<template>
<div>
    <div class="mcc-page-header applicationHeader">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                <section class=" mcc-col mu-d-flex mu-flex-row">

                    <h1 class="mu-mb-00">Application details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

                </section>
                <section>

                    <div role="group" class="mu-d-flex mu-justify-content-end">
                        <div role="group" aria-label="Button group example" class="mcc-button-group mu-mr-05" title="Export">

                            <button class="mcc-button mcc-button--outline" id="exportBtn" @click="exportFiles()">
                                <mcc-icon name="export" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Export</span>
                            </button>
                            <details class="mcc-dropdown">
                                <summary class="mcc-button mcc-button--icon-only mcc-button--outline mu-border-start" aria-haspopup="true">
                                    <span class="[ mcc-button__label ] [ mu-visually-hidden ]">Dropdown</span>
                                    <mcc-icon class="[ mcc-button__dropdown-caret]" name="expand_arrow" aria-hidden="true" style="margin-right:0px !important;"></mcc-icon>
                                </summary>
                                <ul class="mcc-dropdown__menu">
                                    <li>

                                        <button type="button" id="exportAsPDFBtn" title="Export as PDF" @click="exportAsPDF()">
                                            <span class="mcc-button__label">Export as PDF</span>
                                        </button>

                                    </li>
                                </ul>
                            </details>
                        </div>
                        <button class="mcc-button mcc-button--soft-warning mu-mr-05" id="unDeployApplicationBtn" title="Undeploy" :disabled="appDto.deploymentId == null" @click="unDeployApplication()">
                            <mcc-icon name="left_arrow" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Undeploy</span>
                        </button>
                        <button class="mcc-button mcc-button--primary" id="deployApplicationBtn" title="Deploy" :disabled="appDto.deleted != null || !appDto.deployable || (appDto.deploymentId==null && deploymentKeyExpired)" @click="deployApplication()">
                            <mcc-icon name="send" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Deploy</span>
                        </button>

                    </div>

                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Design</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">Applications</a>
                    </li>
                    <li>{{appNameBreadcrumb}}</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-card mu-p-06">
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>

                </div>

            </div>

            <div class="mcc-row " v-if="fetchCall">
                <div class="mcc-col">

                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="deploymentKeyExpired" v-if="deploymentKeyExpired || !isLicenseSet" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                        <p>
                            <strong>Warning!</strong>
                            <br />{{licenseMessage}}
                            <br />
                        </p>
                    </mcc-alert>

                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact " id="disableWarning" v-if="appDto.deleted != null" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                        <p>
                            <strong>Warning!</strong>
                            <br />This application has been disabled and cannot be changed.
                            <br />
                            Reason: {{appDto.deletedReason}}
                        </p>
                    </mcc-alert>

                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="adminProtectedWarning" v-if="isProtected && !appDto.admin" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                        <p>
                            <strong>Warning!</strong>
                            <br />This application has been protected by an administrator and cannot be edited.
                        </p>
                    </mcc-alert>

                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="protectedWarning" v-if="isProtected && appDto.admin" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                        <p>
                            <strong>Warning!</strong>
                            <br />This application has been protected.
                        </p>
                    </mcc-alert>

                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="invalidProcesses" v-if="appDto.deleted == null && !appDto.deployable" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                        <p>
                            <strong>Warning!</strong>
                            <br />This application has invalid
                            process(es) and can not be deployed. Please resolve the errors to
                            enable
                            <b>Deploy application</b> button
                        </p>
                    </mcc-alert>

                </div>

            </div>
            <div class="mcc-row">
                <div class="mcc-col mcc-col-md-12">
                    <form v-if="fetchCall" id="formId" novalidate @submit.prevent="saveApplication()">

                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-card mu-mb-05">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title  ">Details</h2>
                                </div>

                                <div class="mcc-card__body">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03  mfc-form-input-wrapper--width">
                                                <label for="name" class="mfc-label--required">Name</label>
                                                <input type="text" id="name" name="name" required="" ref="name" :disabled="appDto.deleted != null || (isProtected && !appDto.admin) || !appDto.editable" :value="appDto.name" :pattern="nameRegex" @change="updateName($event)" placeholder="Name" maxlength="50">

                                            </div>
                                            <div class="mfc-textarea-wrapper mfc-form-input-container mu-mb-03  mfc-form-input-wrapper--width">
                                                <label for="description" aria-label="Description">Description</label>
                                                <textarea id="description" ref="description" name="description" placeholder="Description" :disabled="appDto.deleted != null || (isProtected && !appDto.admin) || !appDto.editable" :value="appDto.description" :pattern="descRegex" @input="appDto.description = $event.target.value" @change="updateDescription($event)" character-count="" maxlength="100"></textarea>
                                                <div class="mfc-invalid-feedback"></div> <span class="mfc-help-text" v-if="appDto.description">
                                                    You have {{100 - appDto.description.length}} characters remaining
                                                </span>
                                                <span class="mfc-help-text" v-else>
                                                    You have 100 characters remaining
                                                </span>
                                            </div>
                                            <TagInput class=" mfc-form-input-wrapper--width" :disabled="appDto.deleted != null || (isProtected && !appDto.admin) || !appDto.editable" ref="labels" :labels="labelsNew" />
                                            <div class="mcc-row mu-mb-03" v-if="appDto.admin">
                                                <div class="mcc-col">
                                                    <div class="my-2">
                                                        <div class="mfc-checkbox-wrapper mfc-form-input-container" id="protected" name="protected">
                                                            <input type="checkbox" id="Protected" class="mfc-switch" :disabled="appDto.deleted != null || (isProtected && !appDto.admin) || !appDto.editable" :checked="appDto.protected" @change="appDto.protected = $event.target.checked" color="primary">
                                                            <label for="Protected">Protected</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mcc-row mu-mb-03">
                                                <div class="mcc-col ">
                                                    <mcc-alert role="alert" class="mcc-alert mcc-alert--info ">
                                                        <div class="mu-d-flex mu-flex-column">
                                                            <ul class="mu-mb-00">
                                                                <li style="margin-bottom: 0;">
                                                                    <span>Created by</span>
                                                                    <span>{{ ' '+appDto.createdBy}}</span> -
                                                                    <span>{{appDto.createdTime}}</span>
                                                                </li>
                                                                <li v-bind:class="{'d-none':(appDto.lastUpdatedBy == null || appDto.lastUpdatedBy.trim() == '')}" style="margin-bottom: 0;">
                                                                    <span>Last updated by</span>
                                                                    <span>{{ ' '+appDto.lastUpdatedBy}}</span> -
                                                                    <span>{{appDto.updatedTime}}</span>
                                                                </li>

                                                                <li v-bind:class="{'d-none':(appDto.deploymentId == null || appDto.deploymentId.trim() == '')}" style="margin-bottom: 0;">
                                                                    Last deployed
                                                                    <span>{{ ' '+appDto.deploymentPrettyTime}}</span>
                                                                    with ID
                                                                    <span>{{ ' '+appDto.deploymentId}}</span>
                                                                </li>
                                                                <li v-bind:class="{'d-none':(appDto.prettyUndeploymentTime == null || appDto.prettyUndeploymentTime.trim() == '')}" style="margin-bottom: 0;">
                                                                    Last undeployed
                                                                    <span>{{ ' '+appDto.prettyUndeploymentTime}}</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </mcc-alert>
                                                </div>
                                            </div>
                                            <div class="mu-d-flex mu-justify-content-end" v-if="!isProtected || appDto.admin">
                                                <div role="group" class="mcc-burron-group mcc-button-group--spaced">
                                                    <button class="mcc-button mcc-button--soft-warning" type="button" id="disableBtn" v-bind:class="{'d-none':(appDto.deleted != null)}" @click="disableBtnClick()" title="Disable" :disabled="!appDto.editable">
                                                        <mcc-icon name="unavailable" aria-hidden="true"></mcc-icon>
                                                        <span class="mcc-button__label">Disable</span>
                                                    </button>
                                                    <button class="mcc-button mcc-button--primary" type="button" id="enableBtn" v-if="appDto.deleted != null" @click="enableApplication()" title="Enable" :disabled="!appDto.editable">
                                                        <mcc-icon name="undo" aria-hidden="true"></mcc-icon>
                                                        <span class="mcc-button__label">Enable</span>
                                                    </button>
                                                    <router-link v-if="appDto.deleted == null" :to="CONTEXT_PATH + '/design/applications/' + appId + '/copy'">
                                                        <button class="mcc-button mcc-button--outline mu-mr-05" id="copyBtn" title="Copy" type="button">
                                                            <mcc-icon name="copy" aria-hidden="true"></mcc-icon>
                                                            <span class="mcc-button__label">Copy</span>
                                                        </button>
                                                    </router-link>
                                                    <button class="mcc-button mcc-button--success " id="saveBtn" title="Save" v-if="appDto.deleted == null" type="submit" :disabled="!appDto.editable">
                                                        <mcc-icon name="save" aria-hidden="true"></mcc-icon>
                                                        <span class="mcc-button__label">Save</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="mcc-row mu-row-gap-05" v-if="fetchProcessForms">
                
                <div class="mcc-col">
                    
                    <div class="mcc-card fullHeightCard cardWidth">
                        <div v-if="!updateCallProcess" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                        <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                            <div>
                                <h2 class="mcc-card__title">Processes</h2>
                            </div>
                            <div class="mu-d-flex mu-justify-content-end mu-mb-03">
                                <div role="group" class=" mcc-button-group mcc-button-group--spaced">
                                    <button class="mcc-button mcc-button--sm mcc-button--outline" id="copyProcBtn" v-if="!isProtected || appDto.admin" title="Copy" :disabled="appDto.deleted != null || !appDto.editable" @click="copyProcess()">
                                        <mcc-icon name="copy" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Copy</span>
                                    </button>
                                    <button class="mcc-button mcc-button--sm mcc-button--soft-primary" id="addProcBtn" v-if="!isProtected || appDto.admin" title="Add" @click="addProcess()" :disabled="appDto.deleted != null || !appDto.editable">
                                        <mcc-icon name="add" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Add</span>
                                    </button>
                                    <button class="mcc-button mcc-button--outline mcc-button--sm" @click="$refs.processFilter.open()">
                                        <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Filters{{processFilterCount > 0 ? ` (${processFilterCount})` : '(1)'}}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="mcc-card__body">
                            <Drawer ref="processFilter" @reset-filter="resetProcessForm" @apply-filter="submitProcessForm()" title="Process Filters">
                                <section>
                                    <div>
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <form id="formIdd">
                                                <div>
                                                    <div class="mfc-input-wrapper mfc-form-input-container mu-mb-03">
                                                        <label for="name">Name</label>
                                                        <input type="text" name="form-name" maxlength="50" id="name" :pattern="nameRegex" :value="processNameRef" @change="processNameRef = $event.target.value">
                                                    </div>
                                                    <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                                        <fieldset class="mfc-fieldset">
                                                            <legend class="mfc-label">
                                                                Disabled
                                                            </legend>
                                                            <div class="mcc-segmented-buttons__list" ref="radioRef" name="disabled-radioGroup" id="disabled-radioGroup">
                                                                <input type="checkbox" name="disabled-radioGroup" value="deleted" id="deleted" @click="processTypeRef = $event.target.value" :checked="processTypeRef =='deleted'">
                                                                <label class="mcc-segmented-buttons__button" for="deleted">
                                                                    <span class="mcc-segmented-buttons__label">Yes</span>
                                                                </label>
                                                                <input type="checkbox" name="disabled-radioGroup" value="active" id="active" @click="processTypeRef = $event.target.value" :checked="processTypeRef =='active'">
                                                                <label class="mcc-segmented-buttons__button" for="active">
                                                                    <span class="mcc-segmented-buttons__label">No</span>
                                                                </label>
                                                                <input type="checkbox" name="disabled-radioGroup" value=" " id="All" @click="processTypeRef = $event.target.value" :checked="processTypeRef ==' '">
                                                                <label class="mcc-segmented-buttons__button" for="All">
                                                                    <span class="mcc-segmented-buttons__label">All</span>
                                                                </label>
                                                            </div>
                                                        </fieldset>
                                                    </div>
                                                </div>
                                            </form>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </Drawer>
                            <mcc-data-table ref="appProcessList" id="appProcessListId"></mcc-data-table>
                        </div>
                    </div>
                </div>
                <div class="mcc-col">
                    
                    <div class="mcc-card fullHeightCard cardWidth">
                        <div v-if="!updateCallForm" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                        <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                            <div>
                                <h2 class="mcc-card__title">Forms</h2>
                            </div>
                            <div class="mu-d-flex mu-justify-content-end mu-mb-03">
                                <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                    <button class="mcc-button mcc-button--sm mcc-button--outline" id="copyFormBtn" v-if="!isProtected || appDto.admin" title="Copy" :disabled="appDto.deleted != null || !appDto.editable" @click="copyForm()">
                                        <mcc-icon name="copy" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Copy</span>
                                    </button>
                                    <button class="mcc-button mcc-button--sm mcc-button--soft-primary" id="addFormBtn" v-if="!isProtected || appDto.admin" title="Add" @click="addForm()" :disabled="appDto.deleted != null || !appDto.editable">
                                        <mcc-icon name="add" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Add</span>
                                    </button>
                                    <button class="mcc-button mcc-button--outline mcc-button--sm" @click="$refs.formFilter.open()">
                                        <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Filters{{formFilterCount > 0 ? ` (${formFilterCount})` : '(1)'}}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="mcc-card__body ">
                            <Drawer ref="formFilter" @reset-filter="resetForms" @apply-filter="submitFormFilter()" title="Form Filters">
                                <section>
                                    <div>
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <div>
                                                    <form id="formIddd">
                                                    <div class="mfc-input-wrapper mfc-form-input-container mu-mb-03">
                                                        <label for="name">Name</label>
                                                        <input type="text" name="form-name" maxlength="50" id="name" :pattern="nameRegex" :value="formNameRef" @change="formNameRef = $event.target.value">

                                                    </div>
                                                    <div class="mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                                        <fieldset class="mfc-fieldset">
                                                            <legend class="mfc-label">
                                                                Disabled
                                                            </legend>
                                                            <div class="mcc-segmented-buttons__list" ref="radioRefs" name="disabled-radioGroup" id="disabled-radioGroup">
                                                                <input type="checkbox" name="disabled-radioGroup" value="deleted" id="Disabled_radio_choice_button1" @click="formTypeRef = $event.target.value" :checked="formTypeRef =='deleted'">
                                                                <label class="mcc-segmented-buttons__button" for="Disabled_radio_choice_button1">
                                                                    <span class="mcc-segmented-buttons__label">Yes</span>
                                                                </label>
                                                                <input type="checkbox" name="disabled-radioGroup" value="active" id="Disabled_radio_choice_button2" @click="formTypeRef = $event.target.value" :checked="formTypeRef =='active'">
                                                                <label class="mcc-segmented-buttons__button" for="Disabled_radio_choice_button2">
                                                                    <span class="mcc-segmented-buttons__label">No</span>
                                                                </label>
                                                                <input type="checkbox" name="disabled-radioGroup" value=" " id="Disabled_radio_choice_button3" @click="formTypeRef = $event.target.value" :checked="formTypeRef ==' '">
                                                                <label class="mcc-segmented-buttons__button" for="Disabled_radio_choice_button3">
                                                                    <span class="mcc-segmented-buttons__label">All</span>
                                                                </label>
                                                            </div>
                                                        </fieldset>
                                                    </div>
                                                </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </Drawer>
                            <mcc-data-table ref="appFormList" id="appFormListId"></mcc-data-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" ref="disableApplication" id="disableApplicationModal">
            <form novalidate id="disabledDialogForm">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Disable</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog()">
                            <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Button</span>
                        </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div v-if="updateDialog">
                                    <div class="mfc-textarea-wrapper mfc-form-input-container">
                                        <label for="disableReason" class="mfc-label--required">Disable reason</label>
                                        <textarea id="disableReason" name="disableReason" ref="disableReason" :pattern="descRegex" :value="deletedReason" @change="updateReason($event)" @input="deletedReason = $event.target.value" character-count="" required="" maxlength="100" rows="6"></textarea>
                                   <div class="mfc-invalid-feedback"></div>
                                    <span class="mfc-help-text" v-if="deletedReason">
                                        You have {{100 - deletedReason.length}} characters remaining
                                    </span>
                                    <span class="mfc-help-text" v-else>
                                        You have 100 characters remaining
                                    </span> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeDialog()">Close</button>
                            <button type="button" class="mcc-button mcc-button--warning" @click="disableApplication()">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--xs" ref="closeErrorMessage" id="errorDetailsDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Error detail</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeErrorMessage()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div>{{errorMessage}}</div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--info" @click="closeErrorMessage()">Close</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

    
<script>
import ApplicationAPI from "../../../services/ApplicationAPI";
import ApplicationProcessAPI from "../../../services/ApplicationProcessAPI";
import ApplicationFormAPI from "../../../services/ApplicationFormAPI";
import TagInput from "../../common/TagInput.vue";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import ImportExportAPI from "../../../services/ImportExportAPI";
import Utils from "@/script_utils";
import CONSTANTS from '../constant.js'
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage,checkFormAndTextareaValidations
} from '../../../formvalid.js';
import Drawer from '../../common/Drawer.vue';

let PROCESS_TYPE_REFERENCE;
let SELECTED_APPLICATION;
let PROCESS_NAME;
let FORM_TYPE;
let FORM_NAME;

export default {
    name: "ApplicationEdit",
    components: {
        Drawer,
        TagInput
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["application.edit"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            appDto: {},
            updateCall: true,
            dataLoaded: false,
            appNameBreadcrumb: "",
            appId: this.$route.params.appId,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            deletedReason: "",
            fetchCall: false,
            processName: "",
            processType: "active",
            processNameRef: "",
            processTypeRef: "active",
            tableObj: null,
            selectedApplicationRef: "",
            currentPageSize: 10,
            selectedApplication: "",
            formName: "",
            formType: "active",
            formNameRef: "",
            formTypeRef: "active",
            fetchProcessForms: false,
            updateCallProcess: false,
            updateCallForm: false,
            labelsNew: [],
            isProtected: false,
            showHelpText: false,
            updateDialog: false,
            updateFormDialog: false,
            deploymentKeyExpired: false,
            isLicenseSet: true,
            licenseMessage: constantMessages.MESSAGES["license.expired.message"],
            errorMessage: "",
            processFilterCount: 0,
            formFilterCount: 0,
            isDescrptionValid: true,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        PROCESS_TYPE_REFERENCE = CONSTANTS.DATATABLES + window.location.pathname + CONSTANTS.PROCESSTYPE;
        SELECTED_APPLICATION = CONSTANTS.DATATABLES + window.location.pathname + CONSTANTS.SELECTEDAPPLICATION;
        PROCESS_NAME = CONSTANTS.DATATABLES + window.location.pathname + CONSTANTS.PROCESSNAME;
        FORM_TYPE = CONSTANTS.DATATABLES + window.location.pathname + CONSTANTS.FORMTYPE;
        FORM_NAME = CONSTANTS.DATATABLES + window.location.pathname + CONSTANTS.FORMNAME;

        if (localStorage.getItem(CONSTANTS.PROCESSLIST) === CONSTANTS.PROCESSLIST) {
            this.processTypeRef = localStorage.getItem(
                PROCESS_TYPE_REFERENCE
            );
            this.processType = localStorage.getItem(
                PROCESS_TYPE_REFERENCE
            );
            this.selectedApplication = localStorage.getItem(
                SELECTED_APPLICATION
            );
            this.selectedApplicationRef = localStorage.getItem(
                SELECTED_APPLICATION
            );
            this.processNameRef = localStorage.getItem(
                PROCESS_NAME
            );

            this.processName = localStorage.getItem(
                PROCESS_NAME
            );
            this.currentPageSize = parseInt(
                localStorage.getItem(CONSTANTS.PROCESSLISTPAGESIZE)
            );
            localStorage.removeItem(CONSTANTS.PROCESSLISTPAGESIZE);
            localStorage.removeItem(CONSTANTS.PROCESSLIST);
            localStorage.removeItem(
                PROCESS_NAME
            );
            localStorage.removeItem(
                PROCESS_TYPE_REFERENCE
            );
            localStorage.removeItem(
                SELECTED_APPLICATION
            );
        }

        if (localStorage.getItem(CONSTANTS.FORMLIST) === CONSTANTS.FORMLIST) {
            this.formTypeRef = localStorage.getItem(
                FORM_TYPE
            );
            this.formType = localStorage.getItem(
                FORM_TYPE
            );
            this.selectedApplication = localStorage.getItem(
                SELECTED_APPLICATION
            );
            this.selectedApplicationRef = localStorage.getItem(
                SELECTED_APPLICATION
            );
            this.formNameRef = localStorage.getItem(
                FORM_NAME
            );
            this.formName = localStorage.getItem(
                FORM_NAME
            );
            this.currentPageSize = parseInt(
                localStorage.getItem(CONSTANTS.FORMLISTPAGESIZE)
            );
            localStorage.removeItem(CONSTANTS.FORMLISTPAGESIZE);
            localStorage.removeItem(CONSTANTS.FORMLIST);
            localStorage.removeItem(
                FORM_NAME
            );
            localStorage.removeItem(
                FORM_TYPE
            );
            localStorage.removeItem(
                SELECTED_APPLICATION
            );
        }

        ApplicationAPI.getApplicationDetails(this.$route.params.appId)
            .then(result => {
                if (result == null) {
                    self.$router.push(
                        self.CONTEXT_PATH + "/design/applications"
                    );
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching application"
                    });
                    return;
                }
                self.checkDeploymentLicenseExpired();
                self.dataLoaded = true;
                self.appDto = result.data;
                self.appDto.createdTime = new Date(self.appDto.created).toLocaleString("en-GB").replace(/\,/g, '');
                if (self.appDto.lastUpdated != null) {
                    self.appDto.updatedTime = new Date(self.appDto.lastUpdated).toLocaleString("en-GB").replace(/\,/g, '');
                }
                self.appNameBreadcrumb = self.appDto.name;
                self.isProtected = result.data.protected;
                result.data.applicationLabels.forEach(element => {
                    self.labelsNew.push(element.name);
                });
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.application.details"] + " - " + self.appNameBreadcrumb;
                EventBus.$emit("update-pageTitle", pageTitle);
            })
            .finally(() => {
                if (self.dataLoaded) {
                    self.fetchCall = true;
                    self.fetchProcessForms = true;
                    self.updateTagsDisabledState();
                }
            });
    },
    methods: {
        updateReason(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason is required")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason must be valid")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else {
                self.$refs.disableReason.classList.remove("ms-is-invalid")
                self.invalidDisableReason = false;
            }
      
            self.deletedReason = event.target.value;
        },
        getProcessFilterCount() {
            if (this.processNameRef != "")
                this.processFilterCount += 1;
            if (this.processTypeRef != "")
                this.processFilterCount += 1;
        },
        getFormFilterCount() {
            if (this.formNameRef != "")
                this.formFilterCount += 1;
            if (this.formTypeRef != "")
                this.formFilterCount += 1;
        },
        resetProcessForm() {
            this.processFilterCount = 0;
            this.processTypeRef = "active";
            this.selectedApplicationRef = "";
            this.processNameRef = "";
            this.selectedApplication = "";
            this.processName = "";
            this.processType = "active";
            localStorage.clear();
            this.initProcessTable();
            this.updateProcessTemplate();
        },
        resetForms() {
            this.formFilterCount = 0;
            this.formTypeRef = "active";
            this.formNameRef = "";
            this.formName = "";
            this.selectedApplication = "";
            this.formType = "active";
            localStorage.clear();
            this.initFormTable();
            this.updateFormTemplate();
        },
        async updateTagsDisabledState() {
            await this.$nextTick();
            this.loadTables();
            if (this.appDto.deleted != null || (this.isProtected && !this.appDto.admin)) {
                let self = this;
                setTimeout(function () {
                    if ($(self.$refs.labels).length > 0) {
                        $(self.$refs.labels)[0].disabled = true;
                    }
                }, 0)
            }
        },
        submitProcessForm(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.processFilterCount = 0;
            this.getProcessFilterCount();
            this.selectedApplication = this.selectedApplicationRef;
            this.processName = this.processNameRef;
            this.processType = this.processTypeRef;
            this.initProcessTable();
            this.updateProcessTemplate();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        submitFormFilter(e) {
            let form = $('#formIddd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.formFilterCount = 0;
            this.getFormFilterCount();
            this.selectedApplication = this.selectedApplicationRef;
            this.formName = this.formNameRef;
            this.formType = this.formTypeRef;
            this.initFormTable();
            this.updateFormTemplate();
            $('#formIddd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIddd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        saveApplication() {
            let form = $('#formId')
            let self = this;
            if(!this.isDescrptionValid){
                return;
            }
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }            
            this.appDto.labels = this.$refs.labels.value;
            self.updateCall = false;
            ApplicationAPI.saveApplication(this.appDto, this.appId).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        }
                        if (k == "labels") {
                            displayErrorMessage($('#tags'), constantMessages.MESSAGES[response.messages[k]])
                            $('#tags')[0].classList.add('ms-is-invalid')
                            $('.mfc-tags-input')[0].classList.add('ms-is-invalid')
                        }
                    }
                } else {
                    self.appDto = response.data;
                    self.appDto.createdTime = new Date(self.appDto.created).toLocaleString("en-GB").replace(/\,/g, '');
                    if (self.appDto.lastUpdated != null) {
                        self.appDto.updatedTime = new Date(self.appDto.lastUpdated).toLocaleString("en-GB").replace(/\,/g, '');
                    }
                    self.appNameBreadcrumb = self.appDto.name;
                    self.isProtected = response.data.protected;
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    self.updateTagsDisabledState();
                }
            });
        },
        copyProcess() {
            this.setFilterDataInLocalStorage();
            this.$router.push({
                path: this.CONTEXT_PATH +
                    "/design/applications/appprocesses",
                name: "ApplicationProcessList",
                params: {
                    otherProps: {
                        appToCopyId: this.$route.params.appId
                    }
                }
            });
        },
        copyForm() {
            this.$router.push({
                path: this.CONTEXT_PATH +
                    "/design/forms",
                name: "ApplicationForms",
                params: {
                    otherProps: {
                        appToCopyId: this.$route.params.appId
                    }
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value != "" && event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.appDto.name = event.target.value;
        },
        updateDescription(event) {
            let self = this;
            if (event.target.value != "" && event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.length"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescrptionValid = false;
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescrptionValid = false;
            } else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isDescrptionValid = true;
            }
            self.appDto.description = event.target.value;
        },
        initProcessTable() {
            let self = this;
            self.updateCallProcess = false;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#appProcessListId');
            this.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                emptyTemplate: '<p class="text-center m-0">No application processes found</p>',
                columnSearch: false,
                debounceTime: 1000,
                pageSize: 10,
                rowStatusKey: 'rowStatusKey',
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            sortable: true
                        },
                        id: {
                            type: "string",
                            title: "ID",
                            sortable: true,
                            hidden: true
                        },
                        // To display primary process in the table
                        primaryProcess: {
                            type: "String",
                            title: "Primary Process",
                            sortable: true
                        },
                        processDisabled: {
                            type: "string",
                            title: "Disabled",
                            sortable: false
                        },
                        version: {
                            type: "number",
                            title: "Version",
                            sortable: true
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    self.updateCallProcess = false;
                    self.pageStart = start;
                    if (self.tableObj != null) {
                        self.currentPageSize =
                            self.tableObj.tableContext.store.state.pageSize;
                    }

                    let currentPageSize = isNaN(self.currentPageSize) ? 10 : self.currentPageSize;
                    let processType = self.processType === null ? "active" : self.processType;
                    let processName = self.processName === null ? "" : self.processName;
                    let queryString =
                        "start=" +
                        start +
                        "&length=" +
                        currentPageSize +
                        "&sort=" +
                        sortHeader +
                        "&dir=" +
                        sortDirection +
                        "&processName=" +
                        processName +
                        "&currentAppId=" +
                        self.appId +
                        "&processType=" +
                        processType;

                    return ApplicationProcessAPI.getProcesses(queryString).then(result => {
                        let responseData = {
                            totalCount: 0,
                            data: []
                        };
                        responseData.totalCount = result.page.totalElements;
                        if (result.data != null) {
                            responseData.data = result.data;
                        }
                        responseData.data.forEach(function (obj, index) {
                            obj['rowStatusKey'] = '';
                            if (!obj.valid) {
                                obj['rowStatusKey'] = 'danger';
                            }
                        });
                        self.updateCallProcess = true;
                        return responseData;
                    });
                },
                onPageChange: (start, limit) => {
                    self.updateProcessTemplate();
                }
            });
        },
        initFormTable() {
            let self = this;
            self.updateCallForm = false;
            const filesTable = document.querySelector('#appFormListId');
            this.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No application forms found </p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: 10,
                debounceTime: 1000,
                schema: {
                    properties: {
                        id: {
                            type: "string",
                            title: "ID",
                            sortable: true,
                            hidden: true
                        },
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            sortable: true
                        },
                        formDisabled: {
                            type: "string",
                            title: "Disabled",
                            sortable: false
                        },
                        version: {
                            type: "number",
                            title: "Version",
                            sortable: true
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    self.updateCallForm = false;
                    self.pageStart = start;
                    if (self.tableObj != null) {
                        self.currentPageSize =
                            self.tableObj.tableContext.store.state.pageSize;
                    }

                    let currentPageSize = isNaN(self.currentPageSize) ? 10 : self.currentPageSize;
                    let processType = self.formType === null ? "active" : self.formType;
                    let formName = self.formName === null ? "" : self.formName;

                    let queryString =
                        "start=" +
                        start +
                        "&length=" +
                        currentPageSize +
                        "&sort=" +
                        sortHeader +
                        "&dir=" +
                        sortDirection +
                        "&formName=" +
                        formName +
                        "&currentAppId=" +
                        self.appId +
                        "&processType=" +
                        processType;
                    return ApplicationFormAPI.getForms(queryString).then(result => {
                        let responseData = {
                            totalCount: 0,
                            data: []
                        };
                        responseData.totalCount = result.page.totalElements;
                        if (result.data != null) {
                            responseData.data = result.data;
                        }
                        self.updateCallForm = true;
                        return responseData;
                    });
                },
                onPageChange: (start, limit) => {
                    self.updateFormTemplate();
                }
            });
        },
        updateProcessTemplate() {
            let self = this;
            this.$refs.appProcessList
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH +
                                "/design/applications/" +
                                self.appId +
                                "/appprocesses/" +
                                reference.trim()
                            );
                        }
                    });
                });
        },
        updateFormTemplate() {
            let self = this;
            this.$refs.appFormList
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH +
                                "/design/applications/" +
                                self.appId +
                                "/appforms/" +
                                reference.trim()
                            );
                        }
                    });
                });
        },
        exportAsPDF() {
            let self = this;
            return ApplicationAPI.exportAsPDF(self.appId, self.appDto.name);
        },
        deployApplication() {
            let self = this;
            self.updateCall = false;
            return ApplicationAPI.deployApplication(self.appId).then(response => {
                self.updateCall = true;
                if (response.error) {
                    if (response.messages != null && response.messages.deploymentError != null) {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        self.errorMessage = response.messages.deploymentError;

                        setTimeout(function () {
                            $('.error-details-link').click(
                                function () {
                                    document.getElementById("errorDetailsDialog").show();
                                });
                        }, 0)
                    } else {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES["application.deployment.fail"]
                        });
                    }

                } else {
                    self.appDto.deploymentTime = response.data.deploymentTime;
                    self.appDto.deploymentPrettyTime = response.data.deploymentPrettyTime;
                    self.appDto.deploymentId = response.data.deploymentId;
                    self.appDto.undeploymentTime = response.data.undeploymentTime;
                    self.appDto.prettyUndeploymentTime = response.data.prettyUndeploymentTime;
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });

                }
                self.checkDeploymentLicenseExpired();
            });
        },
        closeErrorMessage() {
            this.errorMessage = ''
            this.$refs.closeErrorMessage.close()
        },
        unDeployApplication() {
            let self = this;
            self.updateCall = false;
            return ApplicationAPI.unDeployApplication(self.appId).then(response => {
                self.updateCall = true;
                if (response) {
                    if (response.data == "error.undeploy.application" || response.data == "error.application.notFound") {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.data]
                        });
                    } else {
                        self.appDto.deploymentPrettyTime = null;
                        self.appDto.deploymentTime = null;
                        self.appDto.deploymentId = null;
                        self.appDto.undeploymentTime = response.undeploymentTime;
                        self.appDto.prettyUndeploymentTime = response.prettyUndeploymentTime;
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES["application.undeployment.successful"]
                        });
                    }
                }
                self.checkDeploymentLicenseExpired();
            });
        },
        disableBtnClick() {
            this.deletedReason = "";
            document.getElementById("disableApplicationModal").show();
            this.showDialog()
        },
        closeDialog() {
            let form = $('#disabledDialogForm')
            form[0].classList.remove("ms-was-validated");
            this.$refs.disableApplication.close()
            this.updateDialog = false;

        },
        showDialog() {
            this.updateDialog = true;
        },
        showFormDialog() {
            this.updateFormDialog = true;
        },
        showProcessFilterDialog() {
            this.showDialog()
        },
        disableApplication() {
            let form = $('#disabledDialogForm')
            if(!checkFormAndTextareaValidations('disableReason',this.descRegex,form))
            {
                return;
            }
            
            let self = this;
            self.updateCall = false;
            return ApplicationAPI.disableApplication(
                self.appId,
                self.deletedReason
            ).then(response => {
                self.updateCall = true;
                if (!response.error) {
                    self.appDto.deletedReason = response.data.deletedReason;
                    self.appDto.deleted = response.data.deleted;
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    document.getElementById("disableApplicationModal").close();
                    self.$router.push(self.CONTEXT_PATH + "/design/applications");
                }
            });
        },
        enableApplication() {
            let self = this;
            self.fetchCall = false;
            ApplicationAPI.enableApplication(self.appId)
                .then(response => {
                    if (!response.error) {
                        self.appDto.deletedReason = response.data.deletedReason;
                        self.appDto.deleted = response.data.deleted;
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    }
                })
                .finally(() => {
                    self.fetchCall = true;
                });
        },
        loadTables() {
            let self = this;
            this.initFormTable();
            this.initProcessTable();

        },
        addProcess() {
            this.$router.push(
                this.CONTEXT_PATH +
                "/design/applications/" +
                this.appId +
                "/appprocesses/create"
            );
        },
        addForm() {
            this.$router.push(
                this.CONTEXT_PATH +
                "/design/applications/" +
                this.appId +
                "/appforms/create"
            );
        },
        redirectToList() {
            localStorage.setItem("application", "application");

            this.$router.push(
                this.CONTEXT_PATH + '/design/applications'
            );
        },
        exportFiles() {
            ImportExportAPI.exportFiles('APPLICATION', this.appId)
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem(
                PROCESS_TYPE_REFERENCE,
                this.processType
            );
            localStorage.setItem(
                SELECTED_APPLICATION,
                this.selectedApplication
            );
            localStorage.setItem(
                PROCESS_NAME,
                this.processName
            );

            localStorage.setItem(
                FORM_TYPE,
                this.formType
            );
            localStorage.setItem(
                SELECTED_APPLICATION,
                this.selectedApplication
            );
            localStorage.setItem(
                FORM_NAME,
                this.formName
            );
        },
        checkDeploymentLicenseExpired() {
            let self = this;
            self.deploymentKeyExpired = false;
            self.isLicenseSet = true;
            ApplicationAPI.checkDeploymentExpired()
                .then(response => {
                    if (response.status != null && response.status == 500) {
                        self.deploymentKeyExpired = true;
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.data]
                        });
                    } else {
                        if (response.isApplicationLicenseExpired) {
                            self.licenseMessage = constantMessages.MESSAGES["license.expired.message"];
                            self.deploymentKeyExpired = true;
                        }
                        if (!response.isLicenseSet) {
                            self.licenseMessage = constantMessages.MESSAGES["license.key.notprovided"];
                            self.isLicenseSet = false;
                        }
                    }
                });
        }
    }
};
</script>

    
<style>
.fullHeightCard {
    min-height: 100%;
}

.cardWidth {
    min-width: 560px !important;
}

.mc-forms__valid-feedback {
    display: none;
}

.mc-forms__invalid-feedback {
    display: none;
}

.mc-tags-input__tags {
    width: 50% !important;
}
</style>
